export default "__VITE_ASSET__CIE03q74__"